module.exports = __webpack_public_path__ + "static/img/9.f344159.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/9.png
// module id = m2oN
// module chunks = 0